import Flickity from '../flickity.pkgd.min.js';

export const MediaGallerySlider = {
    init() {
        const sliderContainers = document.querySelectorAll(
            '.single-windsor_properties .media-slider'
        );

        var flickityMainSliders = [];
        var flickityNavSliders = [];

        sliderContainers.forEach((element) => {
            const mainItem = element.querySelector('.media-main');
            const mainNav = element.querySelector('.media-nav');
            const prevButton = element.querySelector('.prev-button');
            const nextButton = element.querySelector('.next-button');

            if (mainItem && mainNav) {
                const mainMedia = new Flickity(mainItem, {
                    wrapAround: false,
                    pageDots: false,
                    prevNextButtons: false,
                    draggable: true,
                    adaptiveHeight: true,
                    lazyLoad: true,
                });

                flickityMainSliders.push(mainMedia);

                const navMedia = new Flickity(mainNav, {
                    asNavFor: mainItem,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: true,
                    draggable: true,
                    freeScroll: true,
                    cellAlign: 'left',
                    groupCells: false,
                    lazyLoad: true,
                });
                flickityNavSliders.push(navMedia);

                let isSyncing = false;

                const updatePageCount = (index) => {
                    const totalSlides = mainMedia.slides.length;
                    const pageCountElement =
                        element.querySelector('.page-count');

                    if (pageCountElement) {
                        pageCountElement.textContent = `${
                            index + 1
                        } / ${totalSlides}`;
                    }

                    if (index === 0) {
                        prevButton.setAttribute('disabled', 'disabled');
                    } else {
                        prevButton.removeAttribute('disabled');
                    }

                    if (index === totalSlides - 1) {
                        nextButton.setAttribute('disabled', 'disabled');
                    } else {
                        nextButton.removeAttribute('disabled');
                    }
                };

                navMedia.on('select', () => {
                    if (!isSyncing) {
                        isSyncing = true;
                        const selectedIndex = navMedia.selectedIndex;
                        mainMedia.select(selectedIndex);
                        isSyncing = false;
                        updatePageCount(selectedIndex);
                    }

                    const totalSlides = navMedia.slides.length;
                    const currentSlideIndex = navMedia.selectedIndex;
                    // console.log(totalSlides, currentSlideIndex);

                    if (currentSlideIndex === totalSlides - 1) {
                        // Last slide: hide the media-nav:after
                        $(
                            '.media-gallery .media-slider.active .media-nav'
                        ).addClass('is-last-slide');
                    } else {
                        // Not the last slide: show the media-nav:after
                        $(
                            '.media-gallery .media-slider.active .media-nav'
                        ).removeClass('is-last-slide');
                    }
                });

                mainMedia.on('select', () => {
                    if (!isSyncing) {
                        isSyncing = true;
                        const selectedIndex = mainMedia.selectedIndex;
                        navMedia.select(selectedIndex);
                        isSyncing = false;
                        updatePageCount(selectedIndex);
                    }
                });

                updatePageCount(navMedia.selectedIndex);

                if (prevButton && nextButton) {
                    prevButton.addEventListener('click', () => {
                        if (navMedia) {
                            navMedia.previous();
                        }
                    });

                    nextButton.addEventListener('click', () => {
                        if (navMedia) {
                            navMedia.next();
                        }
                    });
                }
            } else if (element.id && element.id === 'virtual_tour') {
                // console.log(element);

                const mainMedia = new Flickity(mainItem, {
                    wrapAround: false,
                    pageDots: false,
                    prevNextButtons: true,
                    draggable: true,
                    adaptiveHeight: true,
                    lazyLoad: true,
                });

                flickityMainSliders.push(mainMedia);

                let isSyncing = false;

                const updatePageCount = (index) => {
                    const totalSlides = mainMedia.slides.length;
                    const pageCountElement =
                        element.querySelector('.page-count');

                    if (pageCountElement) {
                        pageCountElement.textContent = `${
                            index + 1
                        } / ${totalSlides}`;
                    }

                    if (index === 0) {
                        prevButton.setAttribute('disabled', 'disabled');
                    } else {
                        prevButton.removeAttribute('disabled');
                    }

                    if (index === totalSlides - 1) {
                        nextButton.setAttribute('disabled', 'disabled');
                    } else {
                        nextButton.removeAttribute('disabled');
                    }
                };

                mainMedia.on('select', () => {
                    if (!isSyncing) {
                        isSyncing = true;
                        const selectedIndex = mainMedia.selectedIndex;
                        // navMedia.select(selectedIndex);
                        isSyncing = false;
                        updatePageCount(selectedIndex);
                    }
                });

                updatePageCount(mainMedia.selectedIndex);

                if (prevButton && nextButton) {
                    prevButton.addEventListener('click', () => {
                        if (mainMedia) {
                            mainMedia.previous();
                        }
                    });

                    nextButton.addEventListener('click', () => {
                        if (mainMedia) {
                            mainMedia.next();
                        }
                    });
                }
            }
        });

        //Virtual Tour Slider

        //Virtual Tour Slider End

        // console.log('flickityMainSliders');
        // console.log(flickityMainSliders);

        const tabLinks = document.querySelectorAll('.tab-link');
        const tabContents = document.querySelectorAll('.tab-content');

        tabLinks.forEach((link) => {
            tabContents.forEach((content) => {
                content.classList.add('hidden');
            });
            link.addEventListener('click', function () {
                const targetTab = this.getAttribute('data-tab');

                tabLinks.forEach((l) => l.classList.remove('active'));
                tabContents.forEach((content) => {
                    content.classList.add('hidden');
                    content.classList.remove('active');
                });

                this.classList.add('active');
                document.getElementById(targetTab).classList.remove('hidden');
                document.getElementById(targetTab).classList.add('active');
            });
        });

        const updateVtHeight = () => {
            const mediaHeight = $('.media-main .flickity-viewport').height();
            // console.log('mediaHeight');
            // console.log(mediaHeight);
            if (mediaHeight) {
                $('.media-main .flickity-viewport .media-cell iframe').height(
                    mediaHeight
                );
            }
        };

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateVtHeight, 300);
        });

        updateVtHeight();

        const onActivateVirtualTour = () => {
            $('.media-gallery .media-slider.tab-content').addClass('hidden');
            $('.media-gallery .media-slider.tab-content').removeClass('active');
            $('#virtual_tour').removeClass('hidden');
            $('#virtual_tour').addClass('active');

            $('.media-filter .media-item').removeClass('active');
            $(".media-filter .media-item[data-tab='virtual_tour']").addClass(
                'active'
            );

            $('html, body').animate(
                {
                    scrollTop: $('[data-tab="virtual_tour"]').offset().top,
                },
                500
            );

            $('.media-filter').animate(
                {
                    scrollLeft: $('.media-filter')[0].scrollWidth,
                },
                500
            );
            // setTimeout(() => {
            flickityMainSliders.forEach((element) => {
                element.resize();
            });
            // }, 1000);
            // $(window).trigger('resize');
        };

        const onActivateGalleryContent = (currentHash) => {
            console.log("onActivateGalleryContent",currentHash);
            var $matchingAnchor = $('a[data-tab="' + currentHash + '"]');
            var $matchingTabContent = $('#' + currentHash);
            // console.log(currentHash);
            if ($matchingAnchor.length && $matchingTabContent.length) {
                // console.log('Matching anchor found:', $matchingAnchor);
                $('.media-filter .media-item').removeClass('active');
                $matchingAnchor.addClass('active');

                $('.media-gallery .media-slider.tab-content').addClass(
                    'hidden'
                );
                $('.media-gallery .media-slider.tab-content').removeClass(
                    'active'
                );
                $($matchingTabContent).removeClass('hidden');
                $($matchingTabContent).addClass('active');

                // console.log('[data-tab="' + $matchingAnchor + '"]');
                $('html, body').animate(
                    {
                        scrollTop: $(
                            '[data-tab="' + currentHash + '"]'
                        ).offset().top,
                    },
                    500
                );

                var targetMenu = $('[data-tab="' + currentHash + '"]'); // Find the target menu item
                var scrollTo =
                    targetMenu.position().left +
                    $('.media-filter').scrollLeft();

                $('.media-filter').animate(
                    {
                        scrollLeft: scrollTo,
                    },
                    500
                );
                console.log(flickityMainSliders);
                flickityMainSliders.forEach((element) => {
                    element.resize();
                });

                console.log(flickityNavSliders);
                flickityNavSliders.forEach((element) => {
                    element.resize();
                });
            } else {
                console.log('No matching anchor found.');
            }
        };

        var onChangeLocationHash = () => {
            if (!window.location.hash) {
                console.log(window.location.hash);
                onActivateGalleryContent('all');
            } else if (window.location.hash === '#virtual-tour') {
                onActivateVirtualTour();
            } else {
                var currentHash = location.hash.substring(1);
                onActivateGalleryContent(currentHash);
                // console.log('matchingTabContent');
                // console.log($matchingTabContent);
            }
        };

        $(window).on('hashchange', function () {
            // alert(window.location.hash);
            // console.log(window.location.hash);
            event.preventDefault();
            onChangeLocationHash();
        });

        if (window.location.hash) {
            onChangeLocationHash();
        }

        $(tabLinks).on('click', function (event) {
            console.log(event);
            event.preventDefault();
            var target = $(this).attr('href');
            history.pushState(null, null, target);
            flickityMainSliders.forEach((element) => {
                element.resize();
            });

            flickityNavSliders.forEach((element) => {
                element.resize();
            });

            setTimeout(() => {
                flickityNavSliders.forEach((element) => {
                    element.resize();
                });
            }, 50);
        });
    },
};
